module.exports = __webpack_public_path__ + "static/media/sg.814c6d65.svg";